import React from "react";
import Skeleton from "react-loading-skeleton";

const ProfileSkeleton = () => {
  return (
    <section className="main-section spacer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <form className="detail_card_wrapper profile_card_wrapper">
              <div className="profile-detail-wrapper d-flex justify-content-end align-items-center">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div className="profile-blk position-relative">
                    <div className="profile_upload">
                      <Skeleton
                        className="form-control"
                        height={85}
                        width={"100%"}
                        borderRadius={"50%"}
                      />
                    </div>
                  </div>

                  <div>
                    <Skeleton
                      className="skeleton-btn  py-2 w-auto"
                      height={50}
                      width={"100%"}
                    />
                  </div>
                </div>
              </div>
              <div className="row g-4">
                {[1, 2, 3, 4, 5].map(() => {
                  return (
                    <div className="col-12 col-md-6">
                      <div className="form-inner-div">
                        <Skeleton
                          className="form-control"
                          height={70}
                          width={"100%"}
                          borderRadius={10}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSkeleton;
